
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/ubytovani",
      function () {
        return require("private-next-pages/[region]/ubytovani.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/ubytovani"])
      });
    }
  